import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Button } from 'primeng/button';

@Component({
  selector: 'app-client-onboarding-wizard-buttons',
  standalone: true,
  imports: [Button],
  template: `
    <div class="text-center mt-2">
      <p-button
        type="button"
        label="Back"
        iconPos="left"
        icon="pi pi-caret-left"
        (click)="back()"
      ></p-button>
      <p-button
        type="button"
        label="Next"
        iconPos="right"
        icon="pi pi-caret-right"
        (click)="next()"
        class="ml-2"
        [disabled]="nextDisabled"
      ></p-button>
    </div>
  `,
})
export class WizardButtonsComponent {
  @Input()
  nextDisabled: boolean | null = false;

  @Output()
  buttonClicked: EventEmitter<string> = new EventEmitter();

  back() {
    this.buttonClicked.emit('back');
  }
  next() {
    this.buttonClicked.emit('next');
  }
}
